
import {API_URL_MAP} from './urls.js'

const mapping =(url,buildConfig)=>{

    // 如果已经是完整的外部 URL，直接返回
    if (url.indexOf("http") == 0) {
      return url;
    }

    // 检查是否需要映射
    let mappedUrl = null;

    // 分离基础路径和查询参数
    const [baseUrl, queryString] = url.split('?');

    // 处理带参数的动态路由
    for (const [oldPath, newPath] of Object.entries(API_URL_MAP)) {
      // 将路径转换为正则表达式，将 {id} 这样的占位符替换为通配符
      const oldPathRegex = new RegExp('^' + oldPath.replace(/\{.*?\}/g, '\\d+') + '$');
      if (oldPathRegex.test(baseUrl)) {
        // 提取URL中的数字参数
        const oldPathParts = oldPath.split('/');
        const urlParts = baseUrl.split('/');
        const params = {};

        // 匹配路径中的参数
        oldPathParts.forEach((part, index) => {
          if (part.includes('{')) {
            const paramName = part.replace(/[{}]/g, '');
            params[paramName] = urlParts[index];
          }
        });

        // 替换新路径中的参数
        mappedUrl = newPath;
        Object.entries(params).forEach(([key, value]) => {
          mappedUrl = mappedUrl.replace(`{${key}}`, value);
        });
        break;
      }
    }

    if (mappedUrl) {
      url = mappedUrl;
    }

    // 如果有查询参数，重新添加
    if (queryString) {
      url = url + '?' + queryString;
    }

    return buildConfig.BASE_URL + url;

}


export default mapping